import { render, staticRenderFns } from "./print-label-modal.vue?vue&type=template&id=94876a76&scoped=true&"
import script from "./print-label-modal.vue?vue&type=script&lang=js&"
export * from "./print-label-modal.vue?vue&type=script&lang=js&"
import style0 from "./print-label-modal.vue?vue&type=style&index=0&id=94876a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94876a76",
  null
  
)

export default component.exports